import { NextRouter } from 'next/router'
import { useEffect } from 'react'
import { useDebouncedCallback } from 'use-debounce'

import { EventDetectionMethod, EventType } from '~/behavior-tracking/types'
import { logUserActivity } from '~/behavior-tracking/utility/view-event-logs.utility'

export default function usePageVisitTracker(router: NextRouter, userId: number | null): void {
  const debouncedPageChangeHandler = useDebouncedCallback(
    async (pagePath: string, currentUserId: number) => {
      const event = {
        eventName: EventType.VISIT_PAGE,
        viewKey: pagePath,
        extra: {
          detectBy: EventDetectionMethod.ROUTER_AS_PATH_CHANGED,
        },
      }

      await logUserActivity(currentUserId, event)
    },
    300,
    { trailing: true, leading: false },
  )

  useEffect(() => {
    if (userId != null) {
      debouncedPageChangeHandler(router.asPath, userId)
    }
  }, [debouncedPageChangeHandler, router.asPath, userId])
}
